import { ThemeCSSVariables } from '@asset-metrix/portal-gateway-client-js';

import { PORTAL_GATEWAY_API_BASE_URL } from '../config';

export function getFavIconUrl(
  portalUiFavIcon: ThemeCSSVariables['--portal-ui-favicon']
) {
  if (!portalUiFavIcon) {
    return '';
  }

  return `${PORTAL_GATEWAY_API_BASE_URL.replace(
    /\/$/,
    ''
  )}${portalUiFavIcon.replace(/(^\/|^url\/?\(|\)$)/g, '')}`;
}
